/* ── ALFATEX INDUSTRIES — THEME JS ─────────────────────── */
document.addEventListener('DOMContentLoaded', function() {

  // NAV SCROLL
  const nav = document.getElementById('nav');
  if (nav) {
    if (!nav.classList.contains('solid')) {
      window.addEventListener('scroll', () => {
        nav.classList.toggle('scrolled', window.scrollY > 40);
      });
    }
  }

  // MOBILE DRAWER
  const burger = document.getElementById('burger');
  const drawer = document.getElementById('drawer');
  const drawerX = document.getElementById('drawerX');
  if (burger && drawer) {
    burger.addEventListener('click', () => drawer.classList.add('open'));
    drawerX.addEventListener('click', () => drawer.classList.remove('open'));
    drawer.addEventListener('click', (e) => { if (e.target === drawer) drawer.classList.remove('open'); });
  }

  // SCROLL REVEAL
  const ro = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: 0.1 });
  document.querySelectorAll('.r').forEach(el => ro.observe(el));

  // HERO IMMEDIATE
  setTimeout(() => {
    document.querySelectorAll('.hero .r, .page-hero .r, .about-hero .r, .quote-page .r').forEach(el => {
      el.classList.add('in');
    });
  }, 150);

  // MEGA MENU — click & hover & keyboard accessibility
  const megaTrigger = document.getElementById('mega-trigger');
  const megaMenu = document.getElementById('mega-menu');
  const navItem = document.querySelector('.nav__item--has-mega');
  let hoverTimeout;
  if (megaTrigger && megaMenu && navItem) {
    megaTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = megaMenu.classList.contains('open');
      megaMenu.classList.toggle('open');
      megaTrigger.setAttribute('aria-expanded', !isOpen);
    });
    megaTrigger.addEventListener('focus', () => {
      megaMenu.classList.add('open');
      megaTrigger.setAttribute('aria-expanded', 'true');
    });
    megaTrigger.addEventListener('blur', () => {
      setTimeout(() => {
        if (!megaMenu.contains(document.activeElement)) {
          megaMenu.classList.remove('open');
          megaTrigger.setAttribute('aria-expanded', 'false');
        }
      }, 100);
    });
    navItem.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      megaMenu.classList.add('open');
      megaTrigger.setAttribute('aria-expanded', 'true');
    });
    navItem.addEventListener('mouseleave', () => {
      hoverTimeout = setTimeout(() => {
        megaMenu.classList.remove('open');
        megaTrigger.setAttribute('aria-expanded', 'false');
      }, 200);
    });
    megaMenu.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      megaMenu.classList.add('open');
      megaTrigger.setAttribute('aria-expanded', 'true');
    });
    megaMenu.addEventListener('mouseleave', () => {
      hoverTimeout = setTimeout(() => {
        megaMenu.classList.remove('open');
        megaTrigger.setAttribute('aria-expanded', 'false');
      }, 200);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        megaMenu.classList.remove('open');
        megaTrigger.setAttribute('aria-expanded', 'false');
        megaTrigger.focus();
      }
    });
  }

  // ACTIVE NAV LINK
  const path = window.location.pathname;
  document.querySelectorAll('.nav__links a').forEach(a => {
    if (a.getAttribute('href') === path) a.classList.add('active');
  });

});
